import { Component, OnInit, Input } from '@angular/core';
import { RouteService } from '../shared/route.service';
import { BoxInfoAlertService } from '../box-info-alert/box-info-alert.service';
import { AlertasCardService } from '../alertas-card/alertas-card.service';
import { GraphicService } from '../shared/graphic.service';
import { NgIf } from '@angular/common';
import { BoxTitleComponent } from '../box-title/box-title.component';
import { BoxInfoTruckComponent } from '../box-info-truck/box-info-truck.component';
import { BoxInfoJourneyComponent } from '../box-info-journey/box-info-journey.component';
import { BoxInfoDeliveryRouterComponent } from '../box-info-delivery-router/box-info-delivery-router.component';
import { BoxInfoAlertComponent } from '../box-info-alert/box-info-alert.component';
import { AlertaRoteiroNotificacaoComponent } from '../alerta-roteiro-notificacao/alerta-roteiro-notificacao.component';
import { ConfigConfirmacaoEntregaComponent } from '../config-confirmacao-entrega/config-confirmacao-entrega.component';
import { BoxInfoRouterComponent } from '../box-info-router/box-info-router.component';
import { BoxHistoricoAcoesComponent } from '../box-historico-acoes/box-historico-acoes.component';
import { BoxRoteirosCrossdockingComponent } from '../box-roteiros-crossdocking/box-roteiros-crossdocking.component';
import { TipoRoteiro } from '../shared/Util';

@Component({
    selector: 'box-info-left',
    templateUrl: './box-info-left.component.html',
    styleUrls: ['./box-info-left.component.css'],
    standalone: true,
    imports: [NgIf, BoxTitleComponent, BoxInfoTruckComponent, BoxInfoJourneyComponent, BoxInfoDeliveryRouterComponent, BoxInfoAlertComponent, AlertaRoteiroNotificacaoComponent, ConfigConfirmacaoEntregaComponent, BoxInfoRouterComponent, BoxHistoricoAcoesComponent, BoxRoteirosCrossdockingComponent]
})
export class BoxInfoLeftComponent implements OnInit {

  classOpen: boolean = true;
  classPullRight: boolean = true;
  classPullDown: boolean = false;
  roteiroCrossdocking = false;
  @Input() roteiro;


  constructor(
    public routeService: RouteService,
    public boxInfoAlertService: BoxInfoAlertService,
    public alertasCardService: AlertasCardService,
    public graphicService : GraphicService
  ) { }

  ngOnInit() {
    this.roteiroCrossdocking = this.roteiro.TipoRoteiroID == TipoRoteiro.Crossdocking;
  }

  showHideBoxMainEditRoute() {
    this.classOpen = !this.classOpen;
    this.classPullRight = !this.classPullRight;
    this.classPullDown = !this.classPullDown;
  }
}
